import { Box } from "@mui/material";
import React, { useEffect } from "react";
import styles from "../../../styles/pages/submit.module.scss";
import styles1 from "../../../styles/pages/home.module.scss";
import EmptyTable from "../../../components/EmptyTable/EmptyTable";
// import NoResult from "../../../components/NoResult/NoResult";
import Filter from "../../../components/Filter/Filter";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useQuery } from "react-query";
import { FetchSubmitedVideos } from "../../../api/functions/submited.videos.api";
import { useState } from "react";
import { useAppSelector } from "../../../hooks/useAppSelector";
import {
  setHasNote,
  setUnreachableSubmitter,
  setMonth,
  setYear,
  setSubmitPlace,
  setFrom,
  setTo,
  setApiActiveTwo,
  setContentBuyerId,
  setInquirerKey,
  setDuplicates,
} from "../../../redux-toolkit/slices/dashboard.purchase.website.slice";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import NoResultTwo from "../../../components/NoResult/NoResultTwo";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import PurchasedWebsiteOnlyTable from "../../AllTable/DashboardTables/PurchasedWebsiteOnlyTable";

function DashboardPurchasedWebsiteOnly() {
  const [page, setPage] = useState(1);
  // console.warn("page", page);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const dispatch = useAppDispatch();

  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const [search, setSearch] = useState("");
  //   const [apiActiveTwo, setApiActiveTwo] = useState(true);

  const {
    confirmed,
    content_buyer_id,
    inquirer_key,
    inquirer_value,
    has_note,
    duplicates,
    unreachable_submitter,
    month,
    year,
    submit_place,
    from,
    to,
    apiActiveTwo,
  } = useAppSelector((s) => s.dashboardPurchaseWebsiteSlice);
  // console.warn("published", published);

  // const [enableQueryOne, setEnableQueryOne] = useState(true);
  // const [enableQueryTwo, setEnableQueryTwo] = useState(true);

  const {
    error,
    data,
    isLoading,
    isRefetching,
    refetch: refetchAgain,
  } = useQuery(
    ["purchase_website_1"],
    async () =>
      FetchSubmitedVideos({
        status: 5,
        page: search ? null : page,
        search,
        purchased: "yes",
        has_note,
        unreachable_submitter,
        country: submit_place,
        [inquirer_key]: [inquirer_value],
        from: month || year ? getStartEndDateTwo(month, year).start_date : from,
        to: month || year ? getStartEndDateTwo(month, year).end_date : to,
        content_buyer_id,
        duplicate: duplicates,
      }),
    {
      enabled: confirmed,
    }
  );

  const {
    error: error2,
    data: data2,
    isLoading: isLoading2,
    isRefetching: isRefetching2,
    refetch: refetchAgain2,
  } = useQuery(
    ["purchase_website_2"],
    async () =>
      FetchSubmitedVideos({
        // status: 1,
        manager_decision: inquirer_key == "manager_id" ? 5 : null,
        quality_team_decision: inquirer_key == "quality_team_id" ? 5 : null,
        awaiting_confirmation: "yes",
        page: search ? null : page,
        [inquirer_key]: [inquirer_value],
        search,
        purchased: "yes",
        has_note,
        unreachable_submitter,
        country: submit_place,
        from: month || year ? getStartEndDateTwo(month, year).start_date : from,
        to: month || year ? getStartEndDateTwo(month, year).end_date : to,
        content_buyer_id,
        duplicate: duplicates,
      }),
    {
      enabled: apiActiveTwo && data ? true : false,
      onSuccess: (d2) => {
        // console.warn("d2", d2?.data?.data);
        if (d2?.data?.data?.length < 1) {
          setApiActiveTwo(false);
        }
      },
    }
  );

  //   console.warn("approved data-------------------------------", data?.data);
  // console.warn(
  //   "approved data2-------------------------------",
  //   data2?.data.data
  // );

  const handlePageChange = (p) => {
    setPage(p);
    handleTriggreFetch();
  };

  useEffect(() => {
    if (confirmed) {
      refetchAgain();
    } else {
      refetchAgain2();
    }
  }, [fetchTrigger]);

  const filterRefetch = () => {
    // console.warn("refetch", confirmed);
    if (confirmed) {
      refetchAgain();
    } else {
      refetchAgain2();
    }
    setOpenFilterModal(false);
  };

  const filtersReset = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setContentBuyerId(null));
    dispatch(setInquirerKey(null));
    dispatch(setDuplicates(null));
    setPage(1);
    setSearch("");
    setOpenFilterModal(false);
    handleTriggreFetch();
  };

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  const handleClearFilterModal = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setUnreachableSubmitter(null));
    setOpenFilterModal(false);
    setPage(1);
    handleTriggreFetch();
  };

  useEffect(() => {
    if (!search) return;

    const debounceTimeout = setTimeout(() => {
      refetchAgain();
    }, 1000);

    return () => {
      clearTimeout(debounceTimeout);
    };
  }, [search]);

  const handleInputChange = (event) => {
    let inputValue = event.target.value;
    setSearch(inputValue);
    if (!inputValue) {
      filtersReset();
    }
  };
  const [filterActive, setFilterActive] = useState(false);

  // console.warn("filterActive", filterActive);

  useEffect(() => {
    if (
      content_buyer_id ||
      inquirer_key ||
      inquirer_value ||
      has_note ||
      duplicates ||
      unreachable_submitter ||
      month ||
      year ||
      submit_place ||
      search
    ) {
      setFilterActive(true);
    } else {
      setFilterActive(false);
    }
  }, [
    content_buyer_id,
    inquirer_key,
    inquirer_value,
    has_note,
    duplicates,
    unreachable_submitter,
    month,
    year,
    submit_place,
    search,
  ]);

  return (
    <>
      <ApiLoader loading={isLoading || isLoading2} />

      <Box className={styles.submitPageWrapper}>
        <Box className={styles1.submitTable}>
          <PurchasedWebsiteOnlyTable
            datas={confirmed ? data?.data : data2?.data}
            handlePageChange={handlePageChange}
            filterRefetch={filterRefetch}
            handleClearFilterModal={filtersReset}
            setPage={setPage}
            page={page}
            confirmed={confirmed}
            filtersReset={filtersReset}
            filterActive={filterActive}
            handleTriggreFetch={handleTriggreFetch}
            loading={isLoading}
            p={{
              search,
              handleInputChange,
              openFilterModal,
              setOpenFilterModal,
              handleTriggreFetch,
              filtersReset,
              data2,
            }}
          />
        </Box>
      </Box>
    </>
  );
}

export default DashboardPurchasedWebsiteOnly;
